import {
  ClockDto,
  ClockingDayDto,
  ClockingDto,
  ClockingMonthDto,
  ClockingRegistryDto
} from '@app/data/dtos/mot/clocking/clocking.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import {
  Clock,
  Clocking,
  ClockingDay,
  ClockingMonth,
  ClockType
} from '@app/entities/models/mot/clocking/clocking.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapClocking: MapFromFn<ClockingDto, Clocking> = (value) =>
  Builder.forModel(Clocking).lastUpdate(value.last_update).months(value.months.map(mapClockingMonth)).build();

export const mapClockingMonth: MapFromFn<ClockingMonthDto, ClockingMonth> = (value) =>
  Builder.forModel(ClockingMonth).month(value.month).days(value.days.map(mapClockingDay)).build();

export const mapClockingDay: MapFromFn<ClockingDayDto, ClockingDay> = (value) =>
  Builder.forModel(ClockingDay)
    .date(value.date)
    .label(value.label)
    .hasError(value.day_clocking_error)
    .clocks(value.clocks.map(mapClock))
    .build();

const mapClockTransfer = (value: ClockingRegistryDto): { time: string; type: ClockType; date: string } => ({
  time: value.time,
  type: value.type === 'man' ? ClockType.MAN : ClockType.CLK,
  date: value.date
});

export const mapClock: MapFromFn<ClockDto, Clock> = (value) =>
  Builder.forModel(Clock)
    .entry(value.entry ? mapClockTransfer(value.entry) : null)
    .exit(value.exit ? mapClockTransfer(value.exit) : null)
    .build();

export const mapClockingData: MapFromFn<IDataResponse<ClockingDto>, Clocking> = (value) => mapClocking(value.data);
